import React from "react";

import { useTranslation } from "react-i18next";

import PaymentOptionImage from "@components/icons/PaymentOptionImage";
import { WrappedNavLink } from "@components/navigation";
import { useRootAppStore } from "@hooks";
import { getCurrentCulture, getSVGExtension } from "@utils";
import { observer } from "mobx-react";

export const PaymentOptions = observer(function PaymentOptions() {
	const { t } = useTranslation();

	const rootStore = useRootAppStore();

	const culture = getCurrentCulture();
	const extension = getSVGExtension();

	const { footerPaymentOptions } = rootStore.paymentOptionsStore;

	if (
		typeof footerPaymentOptions?.map !== "function" ||
		footerPaymentOptions.length === 0
	) {
		return null;
	}

	return (
		<>
			<div className="footer__title">
				{t<string>("FOOTER.PAYMENT_OPTIONS")}
			</div>
			<div className="footer__icons">
				{footerPaymentOptions.map(({ paymentMethodAbrv }) => {
					const paymentMethod = paymentMethodAbrv.toLowerCase();

					return (
						<WrappedNavLink
							key={paymentMethod}
							className="footer__icons__item btn btn--reset"
							to={`/${culture}/info/payment-options`}
						>
							<PaymentOptionImage
								className={`u-icon u-icon--payment u-icon--payment--base u-icon--payment--${paymentMethod}`}
								svgName={paymentMethod + extension}
							/>
						</WrappedNavLink>
					);
				})}
			</div>
		</>
	);
});
